import { render, staticRenderFns } from "./DappDetailedOrbitScrollableTable.vue?vue&type=template&id=08d8ba42&scoped=true"
import script from "./DappDetailedOrbitScrollableTable.vue?vue&type=script&lang=ts"
export * from "./DappDetailedOrbitScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedOrbitScrollableTable.vue?vue&type=style&index=0&id=08d8ba42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8ba42",
  null
  
)

export default component.exports